/**
 * NewsUpdates class handles the expandable/collapsible functionality for news feed items
 * Allows users to show/hide additional news items with "Show More" and "Show Less" buttons
 */
export default class NewsUpdates {
	private newsUpdates: HTMLElement | null
	private ctaExpand: HTMLElement | null
	private ctaExpandContent: HTMLElement | null
	private ctaExpandText: string
	private ctaExpandedText: string
	private collapsibleItems: NodeListOf<HTMLElement> | []
	private isExpanded: boolean = false

	constructor() {
		this.newsUpdates = document.querySelector('.newsUpdates')
		this.ctaExpand = this.newsUpdates?.querySelector('#newsUpdates-expandCta') || null
		this.ctaExpandContent = this.ctaExpand?.querySelector('.cta-text') || null
		this.ctaExpandText = this.ctaExpandContent?.textContent || "Voir plus d'articles"
		this.ctaExpandedText =
			this.ctaExpand?.getAttribute('data-content-expanded') || "Voir moins d'articles"
		this.collapsibleItems = this.newsUpdates?.querySelectorAll('.newsUpdates-item.hidden') || []
		this.isExpanded = false

		this.onCtaExpandClick = this.onCtaExpandClick.bind(this)
	}

	init() {
		this.addEvents()
	}

	addEvents() {
		this.ctaExpand?.addEventListener('click', this.onCtaExpandClick)
	}

	/**
	 * Handle "Cta expand" button click
	 * Toggle extra news feed items and update button UI
	 */
	onCtaExpandClick() {
		if (!this.newsUpdates || !this.ctaExpandContent) return
		this.isExpanded = !this.isExpanded

		for (const item of this.collapsibleItems) {
			item.classList.toggle('hidden')
		}

		this.ctaExpand?.classList.toggle('isExpanded')

		this.ctaExpandContent.textContent = this.isExpanded
			? this.ctaExpandedText
			: this.ctaExpandText

		this.ctaExpand?.setAttribute('aria-expanded', String(this.isExpanded))
	}
}
